var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListingWrapper", {
    staticClass: "reports-listing",
    attrs: {
      title: _vm.translations.title,
      loading: _vm.isLoadingTable,
      isTableLoading: _vm.isLoadingTable,
      pagination: _vm.pagination,
      isResponsiveCentered: ""
    },
    on: { "update-pagination": _vm.updatePagination },
    scopedSlots: _vm._u([
      {
        key: "listingTabs",
        fn: function() {
          return [
            _c("HeadingTabs", {
              attrs: {
                type: "filter",
                tabs: _vm.listingTabs,
                activeTab: _vm.activeTab
              },
              on: { "tab-clicked": _vm.handleTabChange }
            })
          ]
        },
        proxy: true
      },
      {
        key: "settings",
        fn: function() {
          return [
            _c("ReportsListingSettingsHeader", {
              attrs: {
                searchValue: _vm.searchValue,
                filters: _vm.filters,
                totalResults: _vm.totalResults
              },
              on: {
                search: _vm.searchAttributes,
                updateActiveFilters: _vm.updateActiveFilters,
                updateFilter: _vm.updateFilter
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "table",
        fn: function() {
          return [
            _c(
              "CompassTable",
              { attrs: { size: "large", border: false, isCheckable: false } },
              [
                _c("ReportsListingTableHead", {
                  attrs: { columns: _vm.columns },
                  on: { "sort-table-head": _vm.handleSort }
                }),
                _vm._v(" "),
                !_vm.reports.length
                  ? _c(
                      "td",
                      {
                        staticClass: "reports-listing__empty-state__no-result",
                        attrs: { colspan: "100%" }
                      },
                      [
                        _c("TableEmptyStateNoResult", {
                          on: { "reset-filters": _vm.resetReports }
                        })
                      ],
                      1
                    )
                  : _c(
                      "CompassTableBody",
                      _vm._l(_vm.reports, function(report, index) {
                        return _c("ReportsListingTableRow", {
                          key: index,
                          attrs: {
                            report: report,
                            cumulioAuth: _vm.cumulioAuth,
                            columns: _vm.columns
                          }
                        })
                      }),
                      1
                    )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }